import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
    standalone: false,
    selector: '[customBehaviourHost]'
})
export class CustomBehaviourHostDirective {
    constructor(public viewContainerRef: ViewContainerRef) {}
}
